import React, { FormEvent } from 'react';
import styled from 'styled-components';

import MagnifyingGlass from '../../components/icons/MagnifyingGlass';
import { DesktopShow, MobileShow } from '../../components/styled/Common';

import { DeviceQueries } from 'Common/src/components/styled';

const SearchBox = ({ value, onChange, onSearch }: { value: string, onChange: (value: string) => void, onSearch: () => void }) => {
  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSearch();
  }

  return <Wrapper onSubmit={onFormSubmit}>
    <DesktopShow><MagnifyingGlass/></DesktopShow>
    <MobileShow><MagnifyingGlass size={24}/></MobileShow>

    <Input value={value} onChange={(e) => onChange(e.currentTarget.value)} placeholder="Search templates"/>
    <DesktopShow><Submit>Search</Submit></DesktopShow>
  </Wrapper>;
};

const Wrapper = styled.form`
  border-radius: 4px;
  background: #FFF;
  backdrop-filter: blur(7px);
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  margin-bottom: 25px;
  color: #000;
`;

const Input = styled.input`
  background: transparent;
  color: #000;
  flex-grow: 1;
  font-size: 20px;
  border: 0;
  outline: 0;
  font-family: Plus Jakarta Sans, sans-serif;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
  
  @media (${DeviceQueries.mobile}) {
    font-size: 14px;
  }
`;

const Submit = styled.button`
  background-color: var(--sp-bg-color);
  border-radius: 4px;
  width: 159px;
  height: 56px;
  border: 0;

  color: var(--sp-text-color2);
  text-align: center;
  font-family: Plus Jakarta Sans, sans-serif;
  font-size: 20px;
  line-height: 24px; /* 120% */
  letter-spacing: 0.2px;
`;

export default SearchBox;
